import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppColorList, ButtonColors, ButtonSize} from 'app/entities/enums';

@Component({
  selector: 'app-modal-footer',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class ModalFooterComponent implements OnInit {
  @Input() cancelText;
  @Input() acceptText;

  @Input() cancelColor: AppColorList;
  @Input() acceptColor: AppColorList;
  @Input() buttonFontSize: ButtonSize = 'large';
  @Input() size: ButtonSize = 'large';

  @Input() cancelDisable = false;
  @Input() acceptDisable = false;

  @Input() cancelLoading = false;
  @Input() acceptLoading = false;
  @Input() showSkeleton = false;

  @Output() clickButtonCancel: EventEmitter<void> = new EventEmitter();
  @Output() clickButtonAccept: EventEmitter<void> = new EventEmitter();

  clickButtonCancelUsed = false;
  clickButtonAcceptUsed = false;

  ngOnInit() {
    this.checkInputParams();

    this.clickButtonCancelUsed = this.clickButtonCancel.observers.length > 0;
    this.clickButtonAcceptUsed = this.clickButtonAccept.observers.length > 0;
  }

  checkInputParams() {
    // Если в input параметры были переданы пустые значения, заменять их дефолтными
    this.cancelText = this.cancelText || 'Отменить';
    this.acceptText = this.acceptText || 'Применить';
    this.cancelColor = this.cancelColor || 'secondary';
    this.acceptColor = this.acceptColor || 'primary';
  }

  clickCancel() {
    this.clickButtonCancel.emit();
  }

  clickAccept() {
    this.clickButtonAccept.emit();
  }
}
